export default "__VITE_ASSET__BpU1qXxp__"